module.exports = __webpack_public_path__ + "static/media/web-dev.d7b6d665.png";